interface Permissions {
  allowAll: boolean;
  allowUserIds: number[];
}
interface GetPermissionProps {
  permissions: Permissions;
  userId?: number | null;
}

export const getPermission = ({ permissions, userId }: GetPermissionProps): boolean => {
  if (permissions.allowAll) {
    return true;
  }
  if (userId != null && permissions.allowUserIds.includes(userId)) {
    return true;
  }
  return false;
};
